'use strict';
import angular from 'angular';
import seedListMacrosHtmlUrl from './views/seedListMacros.html';

let app = angular.module('app.seedListMacrosComponent', []);

const StandardMacros = [
    'CONNECT_FIRSTNAME',
    'CONNECT_LASTNAME',
    'CONNECT_ADDRESS',
    'CONNECT_ADDRESS2',
    'CONNECT_CITY',
    'CONNECT_STATE',
    'CONNECT_ZIP',
];

// These macros do not need to be displayed as options in the widget, but are valid (and should not come back as RED if found in HTML).
const HiddenMacros = [
    'CONNECT_EMAIL',
    'CONNECT_ID',
    'CONNECT_ORDERID',
    'CONNECT_FLIGHTID',
    'CONNECT_MD5EMAIL',
    'CONNECT_MD5EMAIL_UPPER',
    'CONNECT_MD5EMAIL_LOWER',
    'CONNECT_SHA1EMAIL',
    'CONNECT_SHA256EMAIL',
];

app.component('seedListMacros', {
    bindings: {
        audienceMacroMappings: '<',
        emailMacros: '<',
    },
    templateUrl: seedListMacrosHtmlUrl,
    controller: function () {
        let self = this;
        self.macroList = [];
        self.extras = false;
        if (!self.audienceMacroMappings) {
            self.audienceMacroMappings = [];
        } else {
            self.audienceMacroMappings = Object.values(self.audienceMacroMappings);
        }
        if (!self.emailMacros) {
            self.emailMacros = [];
        } else {
            // This field is sent to us from the backend as a string.
            self.emailMacros = JSON.parse(self.emailMacros);
        }

        const foundStandard = [];
        const foundYours = [];
        const foundExtras = [];
        // Sort the macros found in HTML (in the __email_macros form field) according to whether they are:
        // 1) A standard Bridge macro
        // 2) A user macro which is a header of the Match and Activate CSV file
        // 3) Not found in the Match and Activate CSV file, and not a standard Bridge macro either, aka extra macros.
        //    These extra macros show up in red on the widget.
        self.emailMacros.forEach((macro) => {
            const upperCaseMacro = macro.toUpperCase();
            if (upperCaseMacro != 'EMAIL') {
                if (StandardMacros.includes(upperCaseMacro) || HiddenMacros.includes(upperCaseMacro)) {
                    foundStandard.push(macro);
                } else if (self.audienceMacroMappings.some(mapping => mapping.toUpperCase() == upperCaseMacro)) {
                    foundYours.push(macro);
                } else {
                    foundExtras.push(macro);
                    self.extras = true;
                }
            }
        });
        // Now format the data for use by the HTML page
        let index = 0;
        // First the "Email" macro, which is always there, at the top.
        const m = {};
        m.columnOrder = index + 1;
        m.availableMacro = 'Email';
        m.color = 'black';
        self.macroList[index++] = m;
        // Then standard macros
        foundStandard.forEach((standardMacro) => {
            const m = {};
            m.columnOrder = index + 1;
            m.availableMacro = standardMacro;
            m.color = 'black';
            self.macroList[index++] = m;
        });
        // The other user macros (which were Match and Activate CSV columns)
        foundYours.forEach((yourMacro) => {
            const m = {};
            m.columnOrder = index + 1;
            m.availableMacro = yourMacro;
            m.color = 'black';
            self.macroList[index++] = m;
        });
        // And finally the extras macros, in red
        foundExtras.forEach((extraMacro) => {
            const m = {};
            m.columnOrder = index + 1;
            m.availableMacro = extraMacro;
            m.color = 'red';
            self.macroList[index++] = m;
        });
    }
});
